import { createSlice } from '@reduxjs/toolkit';
import { UniteTypeTpl } from '../../utils/typesAndMaps';

export interface ResultItem {
  format: any;
  formatString: string;
  text: string;
  bytes: string,
  location: string,
  confidence: number,
  angle: number,
  moduleSize: number,
  details: any,
  isDPM: boolean,
  isMirrored: boolean
}

export interface Response {
  message?: string;
  reqId?: string;
  results?: Array<ResultItem>;
  settings?: UniteTypeTpl;
  time?: number;
  isExpired?: boolean;
}

const initialState: Response = {};

const responseSlice = createSlice({
  name: 'decodeResponse',
  initialState,
  reducers: {
    updateResponse: (state, action) => {
      state = action.payload.response;
      return state;
    },
  },
});

export const { updateResponse } = responseSlice.actions;

export default responseSlice.reducer;